import React from 'react'
import { Link } from 'gatsby'

import style from './Header.module.scss'

const Header = ({
  children,
  stroke,
  centered,
  small,
  uppercase,
  right,
  light,
  to
}) => (
  <header
    className={ style.header }
    data-stroke={stroke === ''}
    data-centered={centered === ''}
    data-small={small === ''}
    data-uppercase={uppercase === ''}
    data-right={right === ''}
    data-light={light === ''}
  >
    <span>
      { to ? (
        <Link to={to}>
          { children }
        </Link>
      ) : (
        { children }
      )}
    </span>
  </header>
)

export default Header